export const currencyNumberFormat = '_($* #,##0_);_($* (#,##0);_($* "-"??_);_(@_)';
